<template>
  <div >
    <v-subheader>
      <v-btn color="primary" @click="isHome">
        <v-icon>mdi-home</v-icon>
        Home
      </v-btn>
    </v-subheader>
    <v-container grid-list-sm v-if="products">
      <v-subheader>
        Choose Products from:
        {{category.name}}
      </v-subheader>
      <v-layout wrap>
        <v-flex v-for="product in products" :key="`product-` + product.id" xs2>
          <product-item :product="product" height="200px" width="200px" />

        </v-flex>
      </v-layout>
    </v-container>
    <template>
      <div class="text-center">
        <v-pagination v-model="page" @input="go" :length="lengthPage" :total-visible="5"></v-pagination>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    ProductItem: () => import(/* webpackChunkName: "product-item" */ '@/components/ProductItem.vue')
  },
  data: () => ({
    category: {}, // objek category
    products: [], // daftar buku pada category tersebut
    page: 0,
    lengthPage: 0
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user',
    })
  },
  created() {
    this.go()
  },
  methods: {
    ...mapActions({
      setAlert: 'alert/set',
      setAuth: 'auth/set',
    }),
    go() {
      let config = {
        headers: {
          'Authorization': 'Bearer ' + this.user.api_token,
        },
      }
      let { slug } = this.$route.params
      let url = '/categories/slug/' + slug
      url = url + '?page=' + this.page
      url = encodeURI(url)
      this.axios.get(url, config)
        .then((response) => {
          let { data } = response.data
          let category = data
          this.category = category
          this.products = category.products.data
          this.page = category.products.current_page
          this.lengthPage = category.products.last_page
        })
        .catch((error) => {
          let { responses } = error
          console.log(responses)
        })
    },
    isHome() {
      return this.$router.push({ path: "/" })

    }
  }
};
</script>
